import { render, staticRenderFns } from "./AnalisesMelhorias.vue?vue&type=template&id=2e880900&scoped=true"
import script from "./AnalisesMelhorias.vue?vue&type=script&lang=js"
export * from "./AnalisesMelhorias.vue?vue&type=script&lang=js"
import style0 from "./AnalisesMelhorias.vue?vue&type=style&index=0&id=2e880900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e880900",
  null
  
)

export default component.exports